// ** React Imports
import React, { ReactNode } from 'react'

// ** Source code Imports
import PrivacyPolicy from 'src/views/pages/privacy-policy'
import DocsLayout from 'src/layouts/DocsLayout'

const PrivacyPolicyPage = () => {
  return <PrivacyPolicy />
}

PrivacyPolicyPage.getLayout = (page: ReactNode) => <DocsLayout sx={{ maxWidth: 768, mx: 'auto' }}>{page}</DocsLayout>

PrivacyPolicyPage.acl = {
  action: 'read',
  subject: 'privacy-policy-page'
}

export default PrivacyPolicyPage
